module.exports = function() {
  return new Worker(__webpack_public_path__ + "479b88654536533ab17f.worker.js");
};